import OverlayComponent from 'app_components/commons/OverlayComponent/OverlayComponent'
import ScreenwrapperModule from 'app_components/modules/screenWrapper/screenwrapper'
import Sidebar from 'app_components/modules/sidebar'
import { expand } from 'app_events/app/actions'
import { IAppState } from 'app_events/app/types'
import React, { FC, useState, ReactElement, useCallback, useMemo } from 'react'
import { GrMenu } from 'react-icons/gr'
import { useDispatch, useSelector } from 'react-redux'
import { CombinedReducers } from 'app_events/index';

import "./StudentsAppLayout.scss"
import TextComponent from 'app_components/commons/TextComponent/TextComponent'
import StudentCustomSidebar from './components/StudentCustomSidebar/StudentCustomSidebar'
import HelpStepsService from 'app_services/components/helpSteps/helpStepsService'
import StudentHelpButton from './components/StudentHelpButton/StudentHelpButton'
import JoyRideTooltipCommon from 'app_components/commons/joy-ride/joyRideTooltipCommonLayout';
import StudentsHeader from 'app_components/modules/homeScreens/StudentDashboardPage/components/StudentsHeader/StudentsHeader'

interface IStudentsAppLayoutProps {
  children: ReactElement
  app?: IAppState
}

const StudentsAppLayout: FC<IStudentsAppLayoutProps> = ({ children }) => {
  const [imageNavbarSrc, setImageNavbarSrc] = useState(require('assets/images/logos/logo_white.png'))
  const [imageNavbarAlt, setImageNavbarAlt] = useState('Icontec')
  const dispatch = useDispatch()
  const helpStepsService = useMemo(() => new HelpStepsService(), [])
  const { sidebar } = useSelector((state: CombinedReducers) => state.app)
  const collapse = sidebar?.collapse ?? false

  const handleClickOpenMenu = useCallback(() => {
    dispatch(expand(true))
  }, [dispatch])

  const handleClickCloseMenu = useCallback(() => {
    dispatch(expand(false))
  }, [dispatch])

  const getHelpComponent = useCallback(() => {
    return helpStepsService.renderHelpModule('student_dashboard_v2', {
      children: (
        <StudentHelpButton />
      ),
      type: 'div',
      tooltipComponent: JoyRideTooltipCommon
    }) as ReactElement
  }, [helpStepsService])

  return (
    <div className="students-app-layout">
      <OverlayComponent id="student_dashboard_menu_overlay" open={!!collapse} onClose={handleClickCloseMenu}>
        <StudentCustomSidebar onClose={handleClickCloseMenu}>
          <Sidebar
            imageNavbarSrc={imageNavbarSrc}
            imageNavbarAlt={imageNavbarAlt}
            hideOnClose
            className='students-app-layout--sidebar'
            extraItems={[getHelpComponent()]}
          />
        </StudentCustomSidebar>
      </OverlayComponent>
      <div className="students-app-layout--content">
        <div className='students-app-layout--header'>
          <div className='students-app-layout--menu'>
            <GrMenu onClick={handleClickOpenMenu} />
            <TextComponent className='students-app-layout--menu-text'>
              Menú
            </TextComponent>
          </div>
          <StudentsHeader />
        </div>
        <div className="students-app-layout--main">
          <ScreenwrapperModule
            className='students-app-layout--wrapper'
          >
            <main>
              {children}
            </main>
          </ScreenwrapperModule>
        </div>
      </div>
    </div>
  )
}

export default StudentsAppLayout
